import React from 'react';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Flex, Container } from '../Layout';
import ImageBox from '../ImageBox';
import PromoBox from '../PromoBox';
import squad from '../images/squad.png';
import indoor from '../images/indoor.png';
import coachingTeam from '../images/coaching-team.png';
import team from '../images/team.jpg';
import abf4allKickoffPoster from '../images/abf4all-kickoff-poster.jpg';
import conga from '../images/conga.jpg';

const MainContent = styled(Box)`
  color: ${themeGet('colors.ui.text')};
`;

const Aside = styled(Box)``;

const CallToAction = styled(RouterLink)`
  margin-top: 20px;
  padding: 40px;
  color: white;
  display: block;
  transition: all 0.25s linear;
  background: ${themeGet('colors.brand.primary')};
  overflow: hidden;
  text-decoration: none;
  &:hover {
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0);
  }
  &:hover {
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.3);
  }

  @media (max-width: ${themeGet('breakpoints.0')}) {
    display: none;
  } ;
`;

const Home = () => (
  <Container>
    <Flex flexDirection={['column', 'row']}>
      <MainContent flex="1" pr={['0', '20px']} mb={['20px', '0']}>
        <ImageBox src={squad} tag="Meet The National Teams" link="/national-teams" height={['16rem', '36rem']} />
        <CallToAction to="/about">
          <Box>ABOUT AUSTRALIAN BLIND FOOTBALL</Box>
          <Box>Find out more about us &raquo;</Box>
        </CallToAction>
      </MainContent>
      <Aside flex="1">
        <Box mb="20px">
          <ImageBox src={indoor} tag="Sign up to play" link="/play" height="10rem" />
        </Box>
        <ImageBox src={coachingTeam} tag="Meet the team" link="/contact" height={['16rem', '34rem']} />
      </Aside>
    </Flex>

    <Flex justifyContent="space-between" flexDirection={['column', 'column', 'row']}>
      <PromoBox
        img={team}
        heading="2018 International Tours report"
        // eslint-disable-next-line max-len
        description="Our national blind football and vision impaired futsal teams went overseas for their first international tours in September 2018"
        link="/news"
      />
      <PromoBox
        img={abf4allKickoffPoster}
        heading="ABF4ALL Program"
        description="In 2021, Australian Blind Football is launching ABF4ALL program with community football clubs"
        link="/play"
      />
      <PromoBox img={conga} heading="Support us" description="Donate, Sponsor or Volunteer" link="/support" />
    </Flex>
  </Container>
);

export default Home;



// WEBPACK FOOTER //
// ./src/Home/Home.js